export default __webpack_public_path__ + "static/media/Theme10.b9f70895.jpg";